import { formatRound, formatTruncate } from './NumberFormatter';
const DEFAULT_PRECISION = 2;
export function formatTruncatePriceWithoutCurrency(value, asset) {
    const precision = asset.getPrecision();
    return formatTruncate(value, precision);
}
export function formatTruncatePriceWithCurrency(value, asset) {
    const precision = asset.getPrecision();
    return formatTruncate(value, precision) + ' ' + asset.getName();
}
export function formatRoundPriceWithoutCurrency(value, asset) {
    const precision = asset.getPrecision();
    return formatRound(value, precision);
}
export function formatRoundPriceWithCurrency(value, asset) {
    const precision = asset.getPrecision();
    return formatRound(value, precision) + ' ' + asset.getName();
}
export function formatTruncatePriceByDefaultPrecisionWithoutCurrency(value) {
    return formatTruncate(value, DEFAULT_PRECISION);
}
export function formatRoundPriceByDefaultPrecisionWithoutCurrency(value) {
    return formatRound(value, DEFAULT_PRECISION);
}
export function formatTruncatePriceByDefaultPrecisionWithCurrency(value, currency) {
    return formatTruncate(value, DEFAULT_PRECISION) + ' ' + currency;
}
export function formatRoundPriceByDefaultPrecisionWithCurrency(value, currency) {
    return formatRound(value, DEFAULT_PRECISION) + ' ' + currency;
}
